/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { useLocalization } from '@contexts/LocalizationContext'
import { validationSchema } from './validationSchema'
import { client } from '@utils/client'
import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd'
import UploadImage from './UploadImageFromAntd'
// import moment from 'moment'
dayjs.extend(customParseFormat)
const FormComponent = ({
  handleSubmit,
  defaultValues = {},
  doStatus,
  onCancel,
}) => {
  const { t } = useLocalization()
  const [shopDataState, setShopDataState] = useState([])

  useEffect(() => {
    const fetch = async () => {
      const result = await client
        .get('/shop', {
          params: {
            page: 1,
            limit: 99,
          },
        })
        .then((res) => res.data)
      setShopDataState(result.data)

      return result.data
    }

    fetch()
  }, [])

  const [form] = Form.useForm()

  const style = {
    inputForm: { width: '100%', height: '40px' },
    inputDynamicField: {
      width: '100%',
      height: '40px',
    },
    inputDateForm: { width: '100%', height: '40px' },
    btnStyleSummitAdd: {
      height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleCancel: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
      color: '#56B9C3',
    },
  }
  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const yupSync = {
    async validator({ field }, value) {
      try {
        await validationSchema(t).validateSyncAt(field, { [field]: value })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
  }
  const { RangePicker } = DatePicker
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day').add(-1, 'day')
  }

  return (
    <div style={{ overflow: 'scroll', height: '600px' }}>
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={handleSubmit}
        initialValues={defaultValues}
        requiredMark={false}
        style={{ marginRight: 16 }}
      >
        <div hidden>
          <Form.Item name="id">
            {/* ฝาก Id ไปกับ Form เนื่องจากเป็น modal ฝากไปกับ path ไม่ได้ */}
            <Input />
          </Form.Item>
        </div>

        <Form.Item
          name="shopId"
          label={t('rewards.list.column.shop')}
          rules={[yupSync]}
        >
          <Select
            size={'large'}
            style={style.inputForm}
            options={shopDataState.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
            allowClear
          ></Select>
        </Form.Item>

        <Form.Item
          name="bannerImage"
          label={t('rewards.list.column.bannerImage')}
          rules={[
            {
              required: true,
              message: t('rewards.list.error.bannerImage'),
            },
          ]}
        >
          <UploadImage defaultValueImg={defaultValues.bannerImage} />
        </Form.Item>

        <Form.Item
          name="shortDesc"
          label={t('rewards.list.column.shortDesc50')}
          rules={[yupSync]}
        >
          <Input style={style.inputForm} />
        </Form.Item>

        <Form.Item
          name="desc"
          label={t('rewards.list.column.desc')}
          rules={[yupSync]}
        >
          <Input style={style.inputForm} />
        </Form.Item>

        <Form.Item
          name="pointUsage"
          label={t('rewards.list.column.pointUsage')}
          rules={[yupSync]}
        >
          <Input style={style.inputForm} />
        </Form.Item>

        <Form.Item
          name="totalAmount"
          label={t('rewards.list.column.totalAmount')}
          rules={[yupSync]}
        >
          <Input style={style.inputForm} />
        </Form.Item>

        <Form.Item
          name="usablePerBill"
          label={t('rewards.list.column.usablePerBill')}
          rules={[yupSync]}
        >
          <Input style={style.inputForm} />
        </Form.Item>

        <Form.List name="availableAt">
          {(fields, { add, remove }) => (
            <>
              <div style={{ padding: '0px 0px 8px' }}>
                <label htmlFor="">{t('rewards.list.column.availableAt')}</label>
              </div>

              {fields.map((field, index) => (
                <div key={field.key}>
                  <Row gutter={[16, 0]}>
                    <Col span={22}>
                      <Form.Item
                        {...field}
                        //  label={t('rewards.list.column.availableAt')}
                        rules={[
                          {
                            required: true,
                            message: t('rewards.list.error.availableAt'),
                          },
                        ]}
                      >
                        <Input style={style.inputDynamicField} />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      {index === 0 ? (
                        <PlusCircleOutlined
                          style={{
                            paddingTop: 10,
                            color: '#56B9C3',
                            fontSize: '18px',
                          }}
                          onClick={() => add()}
                        />
                      ) : (
                        <MinusCircleOutlined
                          style={{
                            paddingTop: 10,
                            color: '#56B9C3',
                            fontSize: '18px',
                          }}
                          onClick={() => remove(field.name)}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              ))}
            </>
          )}
        </Form.List>
        <Row style={{ alignItems: 'center' }}>
          <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
            <Col span={12}>{t('rewards.list.column.exchangePeriodStart')}</Col>
            <Col span={12}> {t('rewards.list.column.exchangePeriodEnd')}</Col>
          </Row>
          <Form.Item
            style={{ width: '100%' }}
            name="availableSinceToUntil"
            rules={[
              {
                required: true,
                message: t('rewards.list.error.availableSinceToUntil'),
              },
            ]}
          >
            <RangePicker
              style={style.inputDateForm}
              disabledDate={disabledDate}
              format="YYYY-MM-DD"
            />
          </Form.Item>
        </Row>

        <Row style={{ alignItems: 'center' }}>
          <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
            <Col span={12}>{t('rewards.list.column.periodOfUseStart')}</Col>
            <Col span={12}>{t('rewards.list.column.periodOfUseEnd')}</Col>
          </Row>
          <Form.Item
            style={{ width: '100%' }}
            name="usableSinceToUntil"
            rules={[
              {
                required: true,
                message: t('rewards.list.error.usableSinceToUntil'),
              },
            ]}
          >
            <RangePicker
              style={style.inputDateForm}
              disabledDate={disabledDate}
              format="YYYY-MM-DD"
            />
          </Form.Item>
        </Row>

        <Form.Item {...tailLayout}>
          <div style={{ textAlign: 'center' }}>
            {doStatus === 'create' ? (
              <Button
                type="primary"
                htmlType="submit"
                style={style.btnStyleSummitAdd}
              >
                {t('rewards.shop.form.addData')}
              </Button>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  gap: 16,
                }}
              >
                <Button
                  htmlType="button"
                  style={style.btnStyleCancel}
                  onClick={() => onCancel()}
                >
                  {t('rewards.shop.form.cancel')}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={style.btnStyleSummit}
                >
                  {t('rewards.shop.form.confirm')}
                </Button>
              </div>
            )}
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
